import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { defaultProps } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const box = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.BOX> =>
	createModel({
		type: COMPONENT_TYPE.BOX,
		editorProps: {
			expandable: true,
			expanded: true,
		},
		componentProps: {
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
				},
			},
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						boxType: defaultProps.boxType,
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.BOX>;
